export default __webpack_public_path__ + "static/media/Product Evolution.bf190d0b.png";